import { type ConfigForm } from '../../model';

// Требование бэкенда: при maxAccepts > 0 обязателен windowSeconds >= 1,
// поэтому оба поля персонального лимита валидируются одинаково.
export const validateAcceptRateLimit = (value: string | undefined, values: ConfigForm) => {
    if (values.acceptRateLimitMode !== 'custom') {
        return null;
    }

    return Number(value) >= 1 ? null : 'Укажите целое число не меньше 1';
};
